// Org-level gate for CRM module visibility.
//
// CRM is enabled per-org via the super-admin panel toggle (org.crmEnabled in DB).
// Until a super-admin flips the toggle on, no user in that org ever sees the CRM:
//   - Team Management → CRM permission checkbox is hidden
//   - Sidebar CRM nav item is hidden
//
// isCrmEnabledForOrg accepts:
//   - an org object  { crmEnabled: Boolean }  (preferred — from billing/profile)
//   - null/undefined — falls back to window.__orgProfile (set by Layout after fetch)
//
// canUserAccessCrm(user, org) — pass the org object from billing/profile as 2nd arg.

/**
 * Is the CRM module enabled at all for this org?
 * Pass the org object from billing/profile (has crmEnabled field).
 * Falls back to window.__orgProfile if org is null/undefined.
 */
export function isCrmEnabledForOrg(org) {
  const resolved = (org && typeof org === 'object') ? org : (typeof window !== 'undefined' ? window.__orgProfile : null);
  if (!resolved) return false;
  return resolved.crmEnabled === true;
}

/**
 * Should this specific user see CRM (sidebar icon + accessible)?
 * - Org must have crmEnabled === true (checked via org object)
 * - User must be an org admin (full access) OR have explicit crmAccess permission
 *
 * @param {object} user  - TG user object from AuthContext
 * @param {object} org   - org object from billing/profile (must have crmEnabled); falls back to window.__orgProfile
 */
export function canUserAccessCrm(user, org) {
  if (!user) return false;
  if (!isCrmEnabledForOrg(org)) return false;
  const isAdmin = user.role === 'org_admin' || user.role === 'main_admin';
  if (isAdmin) return true;
  return user.permissions?.crmAccess === true;
}
